import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import AgGrid from '../../components/AgGrid'
import {
    tutorsColDefs,
    programColDefs,
    programPivotColDefs,
    tutorsPivotColDefs,
    inventoryColDefs,
    rentalColDefs,
} from './columnDefs'
import styles from './dataTable.module.scss'

const DataTable = () => {
    const { pathname, search } = useLocation()
    const [type, subtype] = pathname.replace('/data-table/', '').split('/')
    const pageType = subtype || type
    const queryParams = new URLSearchParams(search)
    const initialGridType = queryParams.get('gridType') || 'normal'
    const region = queryParams.get('region') || null // ✅ 지역 정보 추가
    const colDefs = useMemo(() => {
        const colDefsMap = {
            program: programColDefs,
            tutors: tutorsColDefs,
            tools: {
                inventory: inventoryColDefs,
                rental: rentalColDefs,
            },
            rental: rentalColDefs,
            statistics_program: programPivotColDefs,
            statistics_tutor: tutorsPivotColDefs,
        }
        if (type === 'tools') {
            return colDefsMap.tools?.[subtype] || []
        }
        return colDefsMap[pageType] || []
    }, [type, subtype])

    const defaultColDef = useMemo(() => ({
        flex: 1,
        minWidth: 130,
        enablePivot: initialGridType,
        enableRowGroup: true,
        enableValue: true,
        filter: true,
        floatingFilter: true,
    }), [initialGridType])

    const pageTypeTitle = {
        program: '교육실적',
        tutors: '강사정보',
        inventory: '자산 관리',
        rental: '대여 반납',
    }
    const title = pageTypeTitle[pageType]

    return (
        <div className={styles.container}>
            <span className="h7">{title} Ag-Grid 데이터 테이블</span>
            <AgGrid
                pageType={pageType === 'tutors' ? 'tutor' : pageType}
                gridType={initialGridType}
                colDefs={colDefs}
                defaultColDef={defaultColDef}
                region={region} // ✅ 전달
            />
        </div>
    )
}
export default DataTable
